import { Route, Routes } from 'react-router-dom';
import {
    FaqPage,
    HelpCenterPage,
    HelpDocumentDetailPage,
    ResourcesConfigProvider,
    ResourcesOverviewPage,
    ResourcesShell,
    VideoDetailPage,
    VideosPage
} from '@odo/resources-ui';

import apiV2 from '../api/v2';
import { SidebarLayout } from '../layouts/SidebarLayout';
import { NotFound } from '../pages/errors/NotFound';
import { ClientRoute } from './clientRoute';

/**
 * Every resources page now renders inside one `ResourcesShell`, so the three
 * content lists load once for the whole section and the ⌘K search layer is
 * reachable from any depth. The page bodies live in `@odo/resources-ui` and are
 * shared with files-viewer.
 *
 * `noScroll` hands scrolling to the pages: each one keeps its sticky header
 * pinned while its own body scrolls.
 *
 * Read-only on purpose: authoring the library is a files-viewer job, so this
 * host passes neither `canEdit` nor `canDelete` and the shared pages render no
 * New or Edit control here. Practices read the library; ODO writes it.
 */
export const ResourcesRoutes = () => {
    // Admins can sign in here too, and the server would hand them staff-only items.
    return (
        <ResourcesConfigProvider api={apiV2} reserveTopRight audience="external">
            <ClientRoute>
                <SidebarLayout noScroll>
                    <ResourcesShell>
                        <Routes>
                            <Route path="" element={<ResourcesOverviewPage />} />
                            <Route path="faq" element={<FaqPage />} />
                            <Route path="videos" element={<VideosPage />} />
                            <Route path="videos/:slug" element={<VideoDetailPage />} />
                            <Route path="help-center" element={<HelpCenterPage />} />
                            <Route path="help-center/:slug" element={<HelpDocumentDetailPage />} />

                            {/* 404 - Catch all unmatched routes */}
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </ResourcesShell>
                </SidebarLayout>
            </ClientRoute>
        </ResourcesConfigProvider>
    );
};
